import { render, staticRenderFns } from "./WelcomeOffer.vue?vue&type=template&id=06a38165&"
import script from "./WelcomeOffer.vue?vue&type=script&lang=js&"
export * from "./WelcomeOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports